import api from "../../api";

export const PAGE_CONFIG = (tr) => ({
    BREADCRUMB: [
        { label: 'Home', link: '/' },
        { label: 'Journals', link: '/journals' }
    ],
    PAGE_TITLE: tr('pageTitle'),
    PAGE_DESCRIPTION: tr('pageDescription'),
    GET_QUERY_KEY: 'journals',
    SEARCH_DESCRIPTION: tr('searchDescription'),
    SEARCH_PLACEHOLDER: tr('searchPlaceholder'),
    API_CALL: () => api.upload.getUploads(),
    DEFAULT_ERROR_MESSAGE: tr('defaultErrorMessage'),
    SELECT: (data) => data?.data
});

